import React, { useEffect, useState } from 'react';

import { Box, Button, Tab, Tabs } from '@mui/material';
import { ArrowLeft } from 'iconsax-react';

import { OrganizationStatisticsTab } from './OrganizationStatisticsTab';
import { OrganizationUsageTab } from './OrganizationUsageTab';
import { OrganizationUsersTab } from './OrganizationUsersTab';

import {
  useNavigate,
  useParams,
  useSelector,
  useTranslation,
} from 'third-party';

import { superAdminUrl } from 'constants/url';

import { useSuperAdmin } from 'modules/superAdmin';

import { superAdminSelectors } from 'selectors';

// Every tab loads its own data when it mounts, so only the tab in view queries.
const TABS = [
  { labelKey: 'superAdmin.tab.statistics', render: OrganizationStatisticsTab },
  { labelKey: 'superAdmin.tab.users', render: OrganizationUsersTab },
  { labelKey: 'superAdmin.tab.usage', render: OrganizationUsageTab },
] as const;

export const OrganizationDetailPage = () => {
  const { organizationId = '' } = useParams<{ organizationId: string }>();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { loadAllOrganizations, selectSuperAdminOrganization } =
    useSuperAdmin();
  const allOrgsLoaded = useSelector(superAdminSelectors.allOrganizationsLoaded);

  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    if (!allOrgsLoaded) {
      loadAllOrganizations();
    }
  }, [allOrgsLoaded, loadAllOrganizations]);

  useEffect(() => {
    if (organizationId) {
      selectSuperAdminOrganization(organizationId);
    }
  }, [organizationId, selectSuperAdminOrganization]);

  const ActiveTabContent = TABS[activeTab].render;

  return (
    <Box display="flex" flexDirection="column" height="100%" overflow="hidden">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{ borderBottom: 1, borderColor: 'divider', px: 3.5, flexShrink: 0 }}
      >
        <Tabs value={activeTab} onChange={(_e, v) => setActiveTab(v)}>
          {TABS.map(tab => (
            <Tab key={tab.labelKey} label={t(tab.labelKey)} />
          ))}
        </Tabs>
        <Button
          startIcon={<ArrowLeft variant="TwoTone" size="24" />}
          onClick={() => navigate(superAdminUrl())}
          size="small"
          sx={{ fontSize: '0.78rem', color: 'text.secondary' }}
        >
          {t('common.back')}
        </Button>
      </Box>

      <Box flexGrow={1} overflow="auto">
        <ActiveTabContent organizationId={organizationId} />
      </Box>
    </Box>
  );
};
